import { useRef, useState } from "react";
import {
  NativeSyntheticEvent,
  ImageErrorEventData,
  ImageProps,
  ImageLoadEventData,
} from "react-native";

export function useAHImage({
  onLoad,
  onLoadStart,
  onError,
}: {
  onLoad?: ImageProps["onLoad"];
  onLoadStart?: ImageProps["onLoadStart"];
  onError?: ImageProps["onError"];
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] =
    useState<NativeSyntheticEvent<ImageErrorEventData>>();
  const [key, setKey] = useState(0);

  return {
    isLoading,
    error,
    imageProps: {
      key,
      onLoad: (event: NativeSyntheticEvent<ImageLoadEventData>) => {
        setIsLoading(false);
        setError(undefined);
        if (onLoad) {
          onLoad(event);
        }
      },
      onLoadStart: () => {
        setIsLoading(true);
        if (onLoadStart) {
          onLoadStart();
        }
      },
      onError: (error: NativeSyntheticEvent<ImageErrorEventData>) => {
        if (key < 3) {
          setTimeout(() => {
            setKey((oldKey) => oldKey + 1);
          }, 100);
        } else {
          error?.persist();
          setError(error);
        }
        if (onError) {
          console.warn("Error loading image", error);
          onError(error);
        }
      },
    },
  };
}

export function useImageStatus() {
  const [isLoading, setIsLoading] = useState<null | boolean>(null);

  const [error, setError] = useState(false);
  const [key, setKey] = useState(0);

  const setLoadingRef = useRef<ReturnType<typeof setTimeout> | undefined>();

  return {
    isLoading: isLoading === true,
    error,
    imageProps: {
      key,
      onLoad: () => {
        clearTimeout(setLoadingRef.current);
        setIsLoading(false);
        setError(false);
      },
      onLoadStart: () => {
        setLoadingRef.current = setTimeout(() => {
          setIsLoading((p) => (p === null ? true : p));
        }, 100);
      },
      onError: () => {
        if (key < 3) {
          setTimeout(() => {
            setKey((oldKey) => oldKey + 1);
          }, 100);
        } else {
          setError(true);
        }
      },
    },
  };
}
